import React from "react";
import InternCard from "./InternCard";
// import "./css/CardList.css";

const jobPositions = [
  {
    title: "Teaching Assistant Intern",
    image: "image 2.png",
  },
  {
    title: "Business Analyst",
    image: "image 13.png",
  },
  {
    title: "Business Developer",
    image: "image 14.png",
  },
  {
    title: "R&D Intern",
    image: "image 15.png",
  },
  {
    title: "Graphic Designer",
    image: "image 17.png",
  },
  {
    title: "YouTube Content Maker",
    image: "image 18.png",
  },
  {
    title: "Video Editing Intern",
    image: "image 19.png",
  },
  {
    title: "Marketing Intern",
    image: "image 20.png",
  },
];

const CardList = () => {
  return (
    <div className="row g-4 cardlist-below-row">
      {jobPositions.map((job, index) => (
        <InternCard key={index} title={job.title} image={job.image} />
      ))}
    </div>
  );
};

export default CardList;
